module.exports = __webpack_public_path__ + "img/05.0999a55d.jpg";